export function normalizeProfileLocation(value) {
  return (value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function buildProfileLocationUpdates(value) {
  return {
    profileLocation: value || '',
    profileLocationNormalized: normalizeProfileLocation(value),
  };
}
